import { TreeIcon } from "@ui-kit/Tree";

export const ToolExpander = ({ expanded }: { expanded: boolean | null }) =>
	expanded === null ? (
		<span className="size-4 shrink-0" />
	) : (
		<TreeIcon className="size-4 text-muted" icon={expanded ? "chevron-down" : "chevron-right"} />
	);
